import { render, staticRenderFns } from "./ModalFormularioRequisitosDocumentales.vue?vue&type=template&id=2fb5bd26&scoped=true"
import script from "./ModalFormularioRequisitosDocumentales.vue?vue&type=script&lang=js"
export * from "./ModalFormularioRequisitosDocumentales.vue?vue&type=script&lang=js"
import style0 from "./ModalFormularioRequisitosDocumentales.vue?vue&type=style&index=0&id=2fb5bd26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb5bd26",
  null
  
)

export default component.exports